export default [ {
	path: '/enterpriseInfo/',
	asyncComponent: () => import("@/components/Mine/EnterpriseInfo/EnterpriseInfo.vue"),
	title: "企业信息",
	showAppBar: false,
}, {
	path: '/ContractReport/',
	asyncComponent: () => import("@/components/Mine/ContractReport/ContractReport.vue"),
	title: "我的合同",
	showAppBar: false,
}, {
	path: '/contractDetail/',
	asyncComponent: () => import("@/components/Mine/ContractReport/ContractDetail.vue"),
	title: "我的合同",
	showAppBar: false,
}, {
	path: '/aaCompany/',
	asyncComponent: () => import("@/components/Mine/AaCompany/AaCompany.vue"),
	title: "代账公司",
	showAppBar: false,
}, {
	path: '/aaCompanyChange/',
	asyncComponent: () => import("@/components/Mine/AaCompany/AaCompanyChange.vue"),
	title: "切换公司",
	showAppBar: false,
}, {
	path: '/asInfo/',
	asyncComponent: () => import("@/components/Mine/EnterpriseInfo/AccountSetInfo.vue"),
	title: "账套信息",
	showAppBar: false,
}, {
	path: '/changeV/',
	asyncComponent: () => import("@/components/Mine/EnterpriseInfo/changeVersion.vue"),
	title: "切换版本",
	showAppBar: false,
}]
